/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

type CreateRawElementArgs = {
	type: 'element' | 'ref';
	identifier: string;
};

export function createRefElement( identifier: string ): HTMLDivElement {
	return createRawElement( { type: 'ref', identifier } );
}

export function createElement( identifier: string ): HTMLDivElement {
	return createRawElement( { type: 'element', identifier } );
}

function createRawElement( { type, identifier }: CreateRawElementArgs ): HTMLDivElement {
	const element = document.createElement( 'div' );
	element.dataset.type = type;
	element.dataset.identifier = identifier;

	return element;
}
